import { Component, inject } from '@angular/core';

import { SharedModule } from '@app/shared/shared.module';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { faPowerOff } from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  imports: [SharedModule, TranslocoPipe],
  templateUrl: './limited-app.page.html',
  styleUrl: './limited-app.page.scss',
})
export class LimitedAppPage {
  faPowerOff = faPowerOff;
  authenticationService = inject(AuthenticationService);

  logout(): void {
    this.authenticationService.logout();
  }
}
